module.exports = __webpack_public_path__ + "img/a28a2ea.jpg";